import { CAVisibilityRankingSet } from "./CAVisibilityRankings";
import classes from "./CAVisibilityRankings.module.css";

/**
 * Composite Rank Data view — shown in CategoryAnalysis when "Compare Across → By LLM" is active.
 * Renders BE-computed composite data from composite_rank_score context (type "compositeRank" socket).
 * Does NOT affect any other module.
 *
 * Props:
 *   effectiveAttribute : string    — currently selected attribute (e.g. "Top", "Best")
 *   multiLLMs          : string[]  — selected LLMs (used for badge denominator)
 *   compositeData      : object    — composite_rank_score[category][market][persona] from context
 *                                    Shape: { compositeProductRankingsArray, compositeProductRankingsData, productMappingAttribute }
 */
export default function CAVisibilityRankingsComposite({ effectiveAttribute, compositeData }) {
  if (!effectiveAttribute || !compositeData?.compositeProductRankingsArray?.length) return null;

  const {
    compositeProductRankingsArray,
    compositeProductRankingsData,
    productMappingAttribute,
  } = compositeData;

  const indices = productMappingAttribute?.[effectiveAttribute] || [];
  if (!indices.length) return null;

  return (
    <div data-report-section="reach" style={{ width: "100%" }}>
      <div className={classes.container}>
        {indices.map((idx, k) => (
          <CAVisibilityRankingSet
            key={k}
            ranking={compositeProductRankingsArray[idx] || []}
            sectionIndex={k}
            rankingDataItems={compositeProductRankingsData?.[idx] || []}
          />
        ))}
      </div>
    </div>
  );
}
